const mutations = {
  SET_USER (state, str) {
    state.user = str
  },
  SET_TOKEN (state, num){
    state.token = num
  },
  SET_DEPART (state, depart){
    state.department = depart
  },
  SET_XCXID (state, id){
    state.xcxId = id
  },
  SET_XCXUSER (state, user){
    state.xcxUser = user
  },
  SET_XCXREAL (state, real){
    state.xcxReal = real
  },
  ADD_RETOR (state,route){
    state.routeArr.push(route);
  },
  DEL_RETOR (state, depart){
    state.routeArr.pop();
  },
  SET_LOADING (state, isLoad){
    state.isLoading = isLoad;
  },
  SET_DINNER (state, dinner){
    state.isDinner = dinner;
  },
  CHANGE_ENTER(state, enter){
    state.enter = enter;
  },
  CHANGE_PEOPLE(state){
    state.peopleC = !state.peopleC;
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js